import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./KycUIHelpers";

const QTasksUIContext = createContext();

export function useQTasksUIContext() {
  return useContext(QTasksUIContext);
}

export const QTasksUIConsumer = QTasksUIContext.Consumer;

export function KycUIProvider({ TasksUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openEditProductPage: TasksUIEvents?.openEditProductPage,
    openDeleteProductDialog: TasksUIEvents?.openDeleteProductDialog,
    openDeleteTasksDialog: TasksUIEvents?.openDeleteTasksDialog,
    openFetchTasksDialog: TasksUIEvents?.openFetchTasksDialog,
    openUpdateTasksStatusDialog: TasksUIEvents?.openUpdateTasksStatusDialog,
  };

  return (
    <QTasksUIContext.Provider value={value}>
      {children}
    </QTasksUIContext.Provider>
  );
}
